module.exports = __webpack_public_path__ + "static/media/LandBack_1.85f82321.png";